// -----------------------------------------------------
// This file is generated by a script. DO NOT CHANGE IT!
// -----------------------------------------------------
import Nullstack from "nullstack";

class Icon extends Nullstack {

  static hash = '40dd15de8e7cf67eef7f216da22aa5d5';

  render({width, height, length, title, rotation, animation, speed, class: klass, color = "currentColor"}) {
    const transform = rotation ? `rotate(${rotation})` : false;
    const duration = {slow: "1.5s", fast: "0.5s"}[speed] || "1.0s";
    return (
      <svg width={width} height={height} transform={transform} class={klass} viewBox="0 0 512 512">
        {title && <title>{title}</title>}
        {animation === "spin" && <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="360 0 0" to="0 0 0" dur={duration} additive="sum" repeatCount="indefinite" />}
        <rect x="10" y="10" width="492" height="90.4043" rx="17.383" stroke-width={length || 20} stroke={color} stroke-linecap="round" stroke-linejoin="round" fill="none"/>
      <rect x="10" y="411.5957" width="492" height="90.4043" rx="17.383" stroke-width={length || 20} stroke={color} stroke-linecap="round" stroke-linejoin="round" fill="none"/>
      <rect x="10" y="210.7979" width="492" height="90.4043" rx="17.383" stroke-width={length || 20} stroke={color} stroke-linecap="round" stroke-linejoin="round" fill="none"/>
      </svg>
    )
  }

}

export default Icon;
if (module.hot) { module.hot.accept(); Nullstack.updateInstancesPrototypes(Icon, Icon.hash, 'd41d8cd98f00b204e9800998ecf8427e') }